import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/Dashboard';
import Projects from './components/Projects';
import Reports from './components/Reports';
import LandingPage from './components/LandingPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ProjectDetail from './components/ProjectDetail';
import Admin from './components/admin'
import Articles from './components/Articles';
import ArticleCreator from './components/ArticleCreator';
import SubscriptionPlans from './components/SubscriptionPlans';
import { useAuth } from './context/AuthContext';

// Import Calculator Components
import Calculators from './components/Calculators';
import BudgetCalculator from './components/calculators/BudgetCalculator';
import TrueCostOfCreditCalculator from './components/calculators/TrueCostOfCreditCalculator';

// Import Training Components
import BudgetTraining from './components/training/BudgetingTraining';

//Consumers
import Consumers from './components/Consumers';
import MySkills from './components/MySkills';
import SkillsExchange from './components/SkillsExchange';
import MyPeerSupportGroups from './components/MyPeerSupportGroups';


// Wrapper component to handle conditional rendering of navigation
const AppLayout = ({ children }) => {
  const { user } = useAuth();
  return (
    <>
      {user && <Navigation />}
      <main className={user ? 'container mx-auto px-4 py-8' : ''}>
        {children}
      </main>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={
              <AppLayout>
                <LandingPage />
              </AppLayout>
            } />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AppLayout>
                  <Admin />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/login" element={
              <AppLayout>
                <Login />
              </AppLayout>
            } />
            <Route path="/register" element={
              <AppLayout>
                <Register />
              </AppLayout>
            } />

            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/projects" element={
              <ProtectedRoute>
                <AppLayout>
                  <Projects />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/articles" element={
              <ProtectedRoute>
                <AppLayout>
                  <Articles />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/articles/create" element={
              <ProtectedRoute>
                <AppLayout>
                  <ArticleCreator />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/projects/:projectId" element={
              <ProtectedRoute>
                <AppLayout>
                  <ProjectDetail />
                </AppLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/reports" element={
              <ProtectedRoute>
                <AppLayout>
                  <Reports />
                </AppLayout>
              </ProtectedRoute>
            } />


             {/* Calculator Routes */}
             <Route path="/calculators" element={
              <ProtectedRoute>
                <AppLayout>
                  <Calculators />
                </AppLayout>
              </ProtectedRoute>
            } />
             <Route path="/calculators/budget" element={
              <ProtectedRoute>
                <AppLayout>
                  <BudgetCalculator />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/calculators/true-cost-credit" element={
              <ProtectedRoute>
                <AppLayout>
                  <TrueCostOfCreditCalculator />
                </AppLayout>
              </ProtectedRoute>
            } />
            <Route path="/training/budget" element={
              <ProtectedRoute>
                <AppLayout>
                  <BudgetTraining />
                </AppLayout>
              </ProtectedRoute>
            } />
            
         
            <Route path="/subscriptionPlans" element={
              <ProtectedRoute>
                <AppLayout>
                  <SubscriptionPlans />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/consumers" element={
                <ProtectedRoute>
                  <AppLayout>
                    <Consumers />
                  </AppLayout>
                </ProtectedRoute>
            } />
             <Route path="/my-skills" element={
                <ProtectedRoute>
                  <AppLayout>
                    <MySkills />
                  </AppLayout>
                </ProtectedRoute>
            } />
            <Route path="/skills-exchange" element={
                <ProtectedRoute>
                  <AppLayout>
                    <SkillsExchange />
                  </AppLayout>
                </ProtectedRoute>
            } />
            <Route path="/my-peer-support-groups" element={
                <ProtectedRoute>
                  <AppLayout>
                    <MyPeerSupportGroups />
                  </AppLayout>
                </ProtectedRoute>
            } />


            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;